import { IClickMovingState } from '@app/types'

export const initialClickMovingState: IClickMovingState = {
  activeBlockId: null,
  activeGapId: null,
  activeGapBlockId: null,
}

export const DEFAULT_IDLE_TIMEOUT = 60
